import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "catalogservices-container"
}

import ResourceDetail from '@shell/components/ResourceDetail/index.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: '_id',
  setup(__props) {

const route = useRoute();

// Determine if the current resource is catalogservices to hide default header and use custom Masthead in the detail component
const isCatalogServices = route.params.resource === 'catalogservices';

return (_ctx: any,_cache: any) => {
  return isCatalogServices
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ResourceDetail)
      ]))
    : (_openBlock(), _createBlock(ResourceDetail, { key: 1 }))
}
}

})